import React from 'react'

import Icon, { Props } from './Icon'

const IconSpeech: React.FC<Props> = (props) => {
  return (
    <Icon title="" viewBox="0 0 23.23 20.906" {...props}>
      <path d="M17.423 0H5.809A5.889 5.889 0 00.001 5.958v14.174a.775.775 0 001.328.542l3.1-3.186h13a5.888 5.888 0 005.807-5.958V5.958A5.888 5.888 0 0017.423 0zm0 10.453a1.549 1.549 0 111.548-1.549 1.549 1.549 0 01-1.548 1.549zm-4.259-1.549a1.549 1.549 0 11-1.548-1.548 1.548 1.548 0 011.548 1.551zM5.809 7.356A1.549 1.549 0 114.26 8.904a1.548 1.548 0 011.549-1.548z" />
    </Icon>
  )
}

export default IconSpeech
